import { AccountSessionsInfiniteTable } from '@/components/organisms/SessionsInfiniteTable/AccountSessionsInfiniteTable';
import useSegments from '@/segment/useSegments';
import { PageName } from '@/shared/types/segment';

export const AccountChatLogs = () => {
  useSegments(PageName.ANALYTICS_ACCOUNT_CHAT_LOGS);

  return (
    <div className="flex h-full min-h-0 w-full flex-col py-4 pr-4">
      <AccountSessionsInfiniteTable />
    </div>
  );
};
